import React from 'react'
import BenchmarkIcon from '@icons/ovb/benchmark.svg';
import { useIsDimensionSupported } from './hooks';
const BenchmarkIconConditional = ({dimension,selectedKpiMetric}) => {
    const isBenchmarkAndDimensionAndMetricSupported = useIsDimensionSupported(dimension, selectedKpiMetric);
    if(isBenchmarkAndDimensionAndMetricSupported){
        return <BenchmarkIcon></BenchmarkIcon>
    }
    return <span>&emsp;</span> 
}
export default BenchmarkIconConditional;